import _util from '../../utils/';
const bestEmployeeStatisticService = {
  getBestEmployeeList(params, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportBestEmployee/Get',
      params: params,
      success: resolve,
      error: reject
    })
  },
  getBestStarList(params, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportBestStar/Get',
      params: params,
      success: resolve,
      error: reject
    })
  },
  exportBestEmployeeList(params, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportBestEmployee/Export',
      params: params,
      success: resolve,
      error: reject
    })
  },
  exportBestStarList(params, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportBestStar/Export',
      params: params,
      success: resolve,
      error: reject
    })
  },
  getNosubmitList(params, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportNosubmit/Get',
      params: params,
      success: resolve,
      error: reject
    })
  },
  getBestEmployeeReason(params, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportBestEmployeeReason/Get',
      params: params,
      success: resolve,
      error: reject
    })
  },
  getBestStarReason(params, resolve, reject) {
    _util.request({
      url: '/api/HRWorkReportBestStarReason/Get',
      params: params,
      success: resolve,
      error: reject
    })
  },
}

export default bestEmployeeStatisticService;


// WEBPACK FOOTER //
// ./src/services/WorkReport/best-employee-statistic-service.js